<div class="container-fluid alone full-height">
    <div class="row">
      <div class="col-6">
        <h3 class="section-title mb-2">
            {{ 'CONSUMPTION.CONSUMPTION.HAND_DISINFECTANT' | translate }}
        </h3>
      </div>
      <div class="col-6" *ngFor="let item of consumptionData">
        <ul class="advise-container d-flex justify-content-end">
            <li> {{item.year}} </li>
            <li> {{item.wardName | translate | labelSanitizer}} </li>
            <li> {{item.departmentName | translate | labelSanitizer}} </li>
        </ul>
      </div>
    </div>
  </div>

<form [formGroup]="consumptionQuarterPeriodForm">
    <table>
        <thead>
            <tr>
                <th scope="col">{{'CONFIGURE.PERIOD_1' | translate}}
                    <span class="italicFont"> {{'CONSUMPTION.IN_MONTH' | translate}}</span>
                </th>
                <th class="border-left" scope="col"> {{ amountMeasure() }}
                    <span class="italicFont"> ({{unitMeasure()}})</span>
                </th>
                <th class="border-left" scope="col">{{'CONSUMPTION.PATIENT_DAYS' | translate}}
                    <span class="italicFont"> {{'CONSUMPTION.IN_DAYS' | translate}}</span>
                </th>
                <th *ngIf="haiEnabled" class="border-left" scope="col">{{'CONSUMPTION.HAI' | translate}}
                    <span class="italicFont"> {{'CONSUMPTION.OCCURRENCES' | translate}}</span>
                </th>
                <th hidden></th>
            </tr>
        </thead>
        <tbody formArrayName="items" *ngFor="let item of getControls(consumptionQuarterPeriodForm, 'items'); let i = index;">
          <tr [formGroupName]="i">
              <td>{{currentMonth[i] | translate}}</td>
              <td>
                  <input *ngIf="isLiters()" type="text" onlynumber=true class="form-control" min="0"   [mask]="'separator.2'" [thousandSeparator]="''" [dropSpecialCharacters]="false"  [ngClass]="viewConsumption ? '' : 'readOnlyText'" value="{{item.consumptionValue}}" formControlName="consumptionValue">
                  <input *ngIf="isMilliliters()" type="text" onlynumber=true class="form-control" min="0" mask="00000000" [ngClass]="viewConsumption ? '' : 'readOnlyText'" value="{{item.consumptionValue}}" formControlName="consumptionValue">
              </td>
              <td>
                  <input type="text" onlynumber=true class="form-control" min="0" mask="00000000" [ngClass]="viewConsumption ? '' : 'readOnlyText'" value="{{item.patientDays}}" formControlName="patientDays">
              </td>
              <td *ngIf="haiEnabled">
                  <input type="text" onlynumber=true class="form-control" min="0" mask="00000000" [ngClass]="viewConsumption ? '' : 'readOnlyText'" formControlName="haiOccurrences">
              </td>
              <input type="number" class="form-control" [ngClass]="viewConsumption ? '' : 'readOnlyText'" value="{{item.consumptionPeriodID}}" formControlName="consumptionPeriodID" hidden>
          </tr>
        </tbody>
    </table>
</form>

<div class="col-auto d-flex justify-content-end btn-section">
    <button class="btn btn-bd" *ngIf="!viewConsumption" (click)="EditConsumption()">{{ 'CONFIGURE.EDIT' | translate }}</button>
    <button *ngIf="viewConsumption"  (click)="cancelConsupmtionPeriod()" class="btn btn-cancel-bordered-bd mr-4">{{ translationKeys.Authorization.Cancel | translate }}</button>
    <button *ngIf="viewConsumption" class="btn btn-bd" (click)="updateConsumptionPeriod()">{{ translationKeys.Observation.Update | translate }}</button>
</div>
<br>
